import React from 'react';
interface ComboBoxValueProps {
    value: ComboBoxProps;
   }
interface ComboBoxOption {
    value: string;
    label: string;
  }
  
  interface ComboBoxProps {
    label: string;
    options: ComboBoxOption[];
    selectedValue: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    placeholder?: string;
    className?: string;
  }

const ComboBox: React.FC<ComboBoxValueProps> = ({value}) => {
    const { label, options, selectedValue, onChange, placeholder, className } = value;
  return (
    <div className={`flex flex-col ${className}`}>
      {label ? <label className="mb-2">{label}</label> : null}
      <select
        value={selectedValue}
        onChange={onChange}
        className="p-2 border border-gray-300 rounded h-10"
      >
        {placeholder && <option value="" disabled>{placeholder}</option>}
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ComboBox;
